import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#1B1A18] text-[#EFEAE0] border-t border-[#142437]/40">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
          <div>
            <p className="font-serif text-3xl text-[#EFEAE0]">{META.brand}</p>
            <p className="font-serif italic text-base text-[#EFEAE0]/55 mt-1">{META.tagline}</p>
            <p className="text-sm text-[#EFEAE0]/60 mt-6 leading-[1.7] max-w-md">A discretionary private bank, held in partnership and unlisted. Independent of all custodians and product manufacturers since the founding deed of 1908.</p>
          </div>
          {[
            { c: 'London (HQ)', a: '14 St James’s Square, SW1Y 4LB', t: '+44 20 7993 0808' },
            { c: 'Zürich', a: 'Bahnhofstrasse 28, 8001', t: '+41 44 555 0808' },
            { c: 'Singapore', a: '6 Battery Road, #28-02, 049909', t: '+65 6555 0808' },
          ].map(o => (
            <div key={o.c}>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#EFEAE0]/45 mb-3">{o.c}</p>
              <p className="text-sm text-[#EFEAE0]/85 leading-relaxed" dangerouslySetInnerHTML={{ __html: o.a }} />
              <p className="font-mono text-[11px] text-[#EFEAE0]/55 mt-2">{o.t}</p>
            </div>
          ))}
        </div>
        <div className="border-t border-[#EFEAE0]/15 mt-12 pt-6 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#EFEAE0]/40">
          <span>© 2026 {META.brand} · Authorised by the FCA & PRA · A partnership · Reg. No. 008-1908</span>
          <div className="flex gap-6">
            <button onClick={() => setPage('view')} className="hover:text-[#EFEAE0]">House View</button>
            <a href="#" className="hover:text-[#EFEAE0]">Reg. Disclosure</a>
            <a href="#" className="hover:text-[#EFEAE0]">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
